import { createContext, useContext } from 'react';

import { WEDDING_INFO_STEP_SLUG } from '../types';
import { InquiryContextValues } from './types';

const DEFAULT_VALUES: InquiryContextValues = {
  ready: false,
  initialValues: undefined,
  matchFlowView: null,
  fullQuestionnaire: [],
  presentedQuestions: [],
  isRapidRepeatFlow: false,
  inquiryFacets: {},
  storefront: null,
  userContext: null,
  isGuest: true,
  preferences: null,
  servicesOffered: {},
  locationSlug: null,
  phoneNumberPlacement: WEDDING_INFO_STEP_SLUG,
  setNameValues: null,
  nameValues: null,
  setSignedInMidFlow: null,
  signedInMidFlow: false,
  setIsDisplayingLoginForm: null,
  isDisplayingLoginForm: false,
  showServicesValidation: false,
};

export const InquiryContext = createContext<InquiryContextValues>(DEFAULT_VALUES);

export const useInquiryValues: () => InquiryContextValues = () => useContext(InquiryContext);
